import React from "react";
import FadeLoader from "react-spinners/FadeLoader";
import styles from "./styles.module.css";
import { useSelector } from "react-redux";

const PageLoader = () => {
  const loading = useSelector((state) => state.loader.loading);
  const loaderLabel = useSelector((state) => state.loader.label);
  return (
    loading && (
      <div className={styles["page-loader-overlay"]}>
        <div className={styles["loader-conatiner"]}>
          <FadeLoader
            loading={loading}
            speedMultiplier={0.7}
            cssOverride={{
              left: "30px",
              top: "30px",
            }}
            color="var(--theme-text)"
          />
          <label>{loaderLabel}</label>
        </div>
      </div>
    )
  );
};

export default PageLoader;
